import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ title, value, change, changeType, icon, color = 'primary' }) => {
  const getColorClasses = (colorName) => {
    const colors = {
      primary: 'text-primary bg-blue-50',
      success: 'text-success bg-green-50',
      warning: 'text-warning bg-yellow-50',
      error: 'text-error bg-red-50',
      secondary: 'text-secondary bg-emerald-50'
    };
    return colors[colorName] || colors.primary;
  };

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive': return 'text-success';
      case 'negative': return 'text-error';
      default: return 'text-text-secondary';
    }
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-6 shadow-property-card">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${getColorClasses(color)}`}>
          <Icon name={icon} size={24} />
        </div>
        {change && (
          <div className={`flex items-center text-sm ${getChangeColor(changeType)}`}>
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
              size={16} 
              className="mr-1" 
            />
            <span>{change}</span>
          </div>
        )}
      </div>
      
      <div>
        <div className="text-2xl font-bold text-text-primary mb-1">{value}</div>
        <div className="text-sm text-text-secondary">{title}</div>
      </div>
    </div>
  );
};

export default StatsCard;